import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataService, HTTPService, HelperService } from 'app/services';
import { config } from 'app/constants';

@Component({
  selector: 'app-merge-vehicle-dialog',
  templateUrl: './merge-vehicle-dialog.component.html',
  styleUrls: ['./merge-vehicle-dialog.component.scss'],
})
export class MergeVehicleDialogComponent implements OnInit {
  data: any = {};
  primaryVehicle: any = {};
  secondaryVehicle: any = {};
  vehicleList: any;
  noLicense: string = config.noLicense;
  noVIN: string = config.noVIN;
  ODM: any = {};
  isDropdownIcon: boolean = true;
  isPrimaryDropdownIcon: boolean = true;
  isOpenSecondary: boolean = false;
  isOpenPrimary: boolean = false;
  ODMsecondary: any = {};
  vehicleSuggestion: any = [];
  defaultVehicles: any = [];
  primaryVehicleSuggestion: any = [];
  isProcessing: boolean = false;
  isVehicleSidePanel: boolean = true;
  customerId: any = '';
  isDialogOpen: boolean = false;
  isTransferVehicleEnabled: boolean = false;

  constructor(public dConfig: DynamicDialogConfig, public ref: DynamicDialogRef, private httpService: HTTPService, private helperService: HelperService, public dataService: DataService) {}

  ngOnInit() {
    this.isTransferVehicleEnabled = this.dataService.isTransferVehicleEnabled;
    const { primaryVehicle, vehicleList, customerId, isVehicleSidePanel, isDialogOpen } = this.dConfig.data;
    if (customerId) this.customerId = customerId;
    this.isDialogOpen = isDialogOpen;
    if (vehicleList.length) {
      this.vehicleList = vehicleList;
    }
    if (isVehicleSidePanel) this.isVehicleSidePanel = isVehicleSidePanel;
    if (primaryVehicle) {
      this.primaryVehicle = primaryVehicle;

      // Set ODM
      if (this.primaryVehicle.ODM) {
        this.ODM = this.primaryVehicle.ODM.slice(-1)[0];
      }
    }

    if (!this.isDialogOpen) {
      this.vehicleList.forEach((vehicle) => {
        if (vehicle._id !== primaryVehicle._id) {
          this.vehicleSuggestion.push(vehicle);
          this.defaultVehicles.push(vehicle);
        }
      });
    } else {
      this.vehicleSuggestion = this.vehicleList;
      this.primaryVehicleSuggestion = this.vehicleList;
      this.defaultVehicles = this.vehicleList;
    }
  }

  getVehicleName(vehicle) {
    if (vehicle) {
      return vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;
    }
  }

  onSelectVehicle(vehicle, isPrimaryVehicle?) {
    if (!this.isTransferVehicleEnabled || (this.isTransferVehicleEnabled && vehicle.isActive)) {
    if (isPrimaryVehicle) {
      this.primaryVehicle = {};
      this.primaryVehicle = vehicle;
      this.vehicleSuggestion = this.defaultVehicles.filter((vehicleId) => vehicle._id !== vehicleId._id);
      if (this.secondaryVehicle && this.secondaryVehicle.value && !this.secondaryVehicle._id) {
        this.searchSuggestion(this.secondaryVehicle.value);
      }
      if (this.primaryVehicle.ODM && this.primaryVehicle.ODM.length) {
        this.ODM = this.primaryVehicle.ODM.slice(-1)[0];
      }
      this.isPrimaryDropdownIcon = false;
    } else {
      this.secondaryVehicle = {};
      this.secondaryVehicle = vehicle;
      this.primaryVehicleSuggestion = this.defaultVehicles.filter((vehicleId) => vehicle._id !== vehicleId._id);
      if (this.primaryVehicle && this.primaryVehicle.value && !this.primaryVehicle._id) {
        this.searchSuggestion(this.primaryVehicle.value, true);
      }
      if (this.secondaryVehicle.ODM && this.secondaryVehicle.ODM.length) {
        this.ODMsecondary = this.secondaryVehicle.ODM.slice(-1)[0];
      }
      this.isDropdownIcon = false;
    }
  }
}

  handleChange(value, isPrimaryVehicle?) {
    if (isPrimaryVehicle) {
      this.primaryVehicle.value = value;
    } else {
      this.secondaryVehicle.value = value;
    }
  }

  onClearVehicle(event, isPrimaryVehicle) {
    if (isPrimaryVehicle) {
      this.primaryVehicle = {};
      this.isPrimaryDropdownIcon = true;
      if (this.secondaryVehicle && this.secondaryVehicle._id) {
        this.primaryVehicleSuggestion = this.defaultVehicles.filter((vehicle) => vehicle._id !== this.secondaryVehicle._id);
      } else {
        this.vehicleSuggestion = [...this.defaultVehicles];
        this.primaryVehicleSuggestion = [...this.defaultVehicles];
      }
    } else {
      this.secondaryVehicle = {};
      this.isDropdownIcon = true;
      if (this.primaryVehicle && this.primaryVehicle._id) {
        this.vehicleSuggestion = this.defaultVehicles.filter((vehicle) => vehicle._id !== this.primaryVehicle._id);
      } else {
        this.primaryVehicleSuggestion = [...this.defaultVehicles];
        this.vehicleSuggestion = [...this.defaultVehicles];
      }
    }
  }

  toggleSecondary() {
    this.isOpenSecondary = !this.isOpenSecondary;
  }

  togglePrimary() {
    this.isOpenPrimary = !this.isOpenPrimary;
  }

  closeDuplicateVehicleModal(data: any) {
    this.ref.close({ type: 'close' });
  }

  searchSuggestion(query: string, isPrimaryVehicle?) {
    if (isPrimaryVehicle) {
      this.primaryVehicleSuggestion = [];
      query = this.helperService.trimString(query);
      this.primaryVehicleSuggestion = this.defaultVehicles.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
      if (this.secondaryVehicle && this.secondaryVehicle._id) {
        this.primaryVehicleSuggestion = this.primaryVehicleSuggestion.filter((vehicle) => vehicle._id !== this.secondaryVehicle._id);
      } else {
        this.primaryVehicleSuggestion = [...this.primaryVehicleSuggestion];
      }
    } else {
      this.vehicleSuggestion = [];
      query = this.helperService.trimString(query);
      this.vehicleSuggestion = this.defaultVehicles.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
      if (this.primaryVehicle && this.primaryVehicle._id) {
        this.vehicleSuggestion = this.vehicleSuggestion.filter((vehicle) => vehicle._id !== this.primaryVehicle._id);
      } else {
        this.vehicleSuggestion = [...this.vehicleSuggestion];
      }
    }
  }

  onClearSuggestion(isPrimaryVehicle?) {
    if (isPrimaryVehicle) {
      this.primaryVehicle = {};
      if (this.secondaryVehicle && this.secondaryVehicle._id) {
        this.primaryVehicleSuggestion = this.defaultVehicles.filter((vehicle) => vehicle._id !== this.secondaryVehicle._id);
      } else {
        this.primaryVehicleSuggestion = [...this.defaultVehicles];
      }
    } else {
      this.secondaryVehicle = {};
      if (this.primaryVehicle && this.primaryVehicle._id) {
        this.vehicleSuggestion = this.defaultVehicles.filter((vehicle) => vehicle._id !== this.primaryVehicle._id);
      } else {
        this.vehicleSuggestion = [...this.defaultVehicles];
      }
    }
  }

  handleSubmit() {
    if (this.isProcessing) {
      return;
    }
    const data = {
      baseVehicleId: this.primaryVehicle._id,
      duplicateVehicleId: this.secondaryVehicle._id,
    };
    this.isProcessing = true;

    this.httpService.mergeVehicle(this.customerId, data).then(
      (x) => {
        this.dataService.sendData(this.dataService.typePassData('merge-vehicle', { customerId: this.customerId }));
        this.ref.close();
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }
}
